export type HEXWithAlpha = string;

export interface ICellStyleResponseFont
{
    fontName:string;
    fontSize:number;
    textBold:boolean;
    textItalic:boolean;
    textStrikethrough:boolean;
    textUnderline:boolean;
}

export interface ICellStyleResponseBorder
{
    type:CellStyleResponseBorderType;
    color:HEXWithAlpha;
}

export enum CellStyleResponseBorderType
{
    None = "None",
    Grid = 'Grid',
    Thin = "Thin",
    Medium = "Medium",
    Dashed = "Dashed",
    Dotted = "Dotted",
    Thick = "Thick",
    Double = 'Double',
    Hair = "Hair",
    Medium_dashed = "Medium dashed",
    Dash_dot = "Dash dot",
    Medium_dash_dot = "Medium dash dot",
    Dash_dot_dot = "Dash dot dot",
    Medium_dash_dot_dot = "Medium dash dot dot",
    Slanted_dash_dot = "Slanted dash dot",
}

export class CellStyleResponse
{
    public readonly bgColor:HEXWithAlpha;
    public readonly textColor:HEXWithAlpha;
    public readonly font:ICellStyleResponseFont;
    public readonly textAlign:string;
    public readonly vertAlign:string;
    public readonly wrapped:boolean;
    public readonly borderTop:ICellStyleResponseBorder;
    public readonly borderRight:ICellStyleResponseBorder;
    public readonly borderBottom:ICellStyleResponseBorder;
    public readonly borderLeft:ICellStyleResponseBorder;

    constructor(json:any)
    {
        this.bgColor = json['bgColor'];
        this.textColor = json['textColor'];
        this.font = json['font'];
        this.textAlign = json['textAlign'];
        this.vertAlign = json['vertAlign'];
        this.wrapped = json['wrapped'];
        this.borderTop = json['borderTop'];
        this.borderRight = json['borderRight'];
        this.borderBottom = json['borderBottom'];
        this.borderLeft = json['borderLeft'];
    }
}
